export default {
  LOAD_NOTIFICATIONS_LIST_START: 'LoadNotificationsListStart',
  LOAD_NOTIFICATIONS_LIST_END: 'LoadNotificationsListEnd',
  FILTER_NOTIFICATIONS_LIST: 'FilterNotificationsList',
  SORT_NOTIFICATIONS_LIST: 'SortNotificationsList',
  OPEN_NOTIFICATIONS_DELETE_CONFIRM_DIALOG: 'OpenNotificationsDeleteConfirmDialog',
  CLOSE_NOTIFICATIONS_DELETE_CONFIRM_DIALOG: 'CloseNotificationsDeleteConfirmDialog'
};